/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'doT',
	'text!./templates/ShapeWidgetColorSet.html'
], (dot, templateString) => {
	class ShapeWidgetColorSet {
		static getColorStyles(colorService, paletteId) {
			/* .shapeWidget .border-{{=color.name}} { 
			* This colour value is a hack for the Line shape because it contains stroke="currentColor" in it.
			* If something changes the colour at this level in the DOM or below it but before the line
			* then the line will use that colour value instead of the one being defined below this comment.
			*/

			return Promise.resolve(ShapeWidgetColorSet.dotTemplate({
				colors: colorService.getColorSet(paletteId)
			}));
		}
	}

	ShapeWidgetColorSet.dotTemplate = dot.template(templateString);

	return ShapeWidgetColorSet;
});
